import { render, staticRenderFns } from "./InjuryCaseSteps.vue?vue&type=template&id=3783f128"
import script from "./InjuryCaseSteps.vue?vue&type=script&lang=js"
export * from "./InjuryCaseSteps.vue?vue&type=script&lang=js"
import style0 from "./InjuryCaseSteps.vue?vue&type=style&index=0&id=3783f128&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports